import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-vini-inclusi',
  templateUrl: './vini-inclusi.component.html',
  styleUrls: ['./vini-inclusi.component.css']
})
export class ViniInclusiComponent implements OnInit {

  @Input() vini: any[] = [];
  vinoSelezionato = null;

  sliceValue = 3;

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  dettaglioVino(vino) {
    this.vinoSelezionato = vino;
  }

  piu() {
    this.sliceValue = this.vini.length;
  }

  meno() {
    this.sliceValue = 3;
  }


  // dettaglioVino(vino: any) {
  //   this.dialog.open(VinoDetailComponent, {
  //     width: '450px',
  //     data: vino,
  //     positionRelativeToElement: this.myElement,
  //   });
  // }

}
